import type React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import {
  ForgotPasswordPage,
  NotFoundPage,
  RegisterPage,
  ResetPasswordPage,
  SignedInRedirect,
  SignInLinkPage,
  SignInPage,
  SignOutPage,
  VerifyEmailConfirmPage,
  VerifyEmailPage,
} from './pages';
import { AuthPreviewGate } from './preview';
import { ROUTES } from './routes';

/** / has no screen of its own: sign-in, keeping the query string (return_to, provider) and hash. */
const HomeRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate replace to={{ pathname: ROUTES.signIn, search, hash }} />;
};

const Gated = ({ children }: { children: React.ReactNode }) => (
  <AuthPreviewGate required={AUTH_PREVIEW_REQUIRED}>{children}</AuthPreviewGate>
);

function Application() {
  return (
    <Routes>
      <Route path={ROUTES.home} element={<HomeRedirect />} />
      <Route
        path={ROUTES.signIn}
        element={
          <Gated>
            <SignInPage />
          </Gated>
        }
      />
      <Route
        path={ROUTES.register}
        element={
          <Gated>
            <RegisterPage />
          </Gated>
        }
      />
      <Route
        path={ROUTES.verifyEmail}
        element={
          <Gated>
            <VerifyEmailPage />
          </Gated>
        }
      />
      <Route
        path={ROUTES.verifyEmailConfirm}
        element={
          <Gated>
            <VerifyEmailConfirmPage />
          </Gated>
        }
      />
      {/* Not gated: signing out always works. */}
      <Route path={ROUTES.signOut} element={<SignOutPage />} />
      {/* Not gated: a player who forgot their password can always reset it. */}
      <Route path={ROUTES.forgotPassword} element={<ForgotPasswordPage />} />
      <Route path={ROUTES.resetPassword} element={<ResetPasswordPage />} />
      {/* Not gated: /forgot-password, which isn't either, sends sign-in links. */}
      <Route path={ROUTES.signInLink} element={<SignInLinkPage />} />
      {/* Old links and history entries: straight on to the game. */}
      <Route path={ROUTES.signedIn} element={<SignedInRedirect />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default Application;
